export const GET_PIPELINE_HERO_STATS = gql`
  query GetPipelineHeroStats($filters: StatusLogFiltersInput) {
    pipelineHeroStats(filters: $filters) {
      current {
        totalLeads
        totalHired
        cohortHired
        conversionRate
        avgDaysToHire
        retention
      }
      previous {
        totalLeads
        totalHired
        cohortHired
        conversionRate
        avgDaysToHire
        retention
      }
      notContactedCount
    }
  }
`

export const GET_PIPELINE_VELOCITY_METRICS = gql`
  query GetPipelineVelocityMetrics($input: VelocityMetricInput!) {
    pipelineVelocityMetrics(input: $input) {
      segmentId
      segmentName
      avgDays
      count
    }
  }
`

export const GET_COMPANY_DATE_CUSTOM_FIELDS = gql`
  query GetCompanyDateCustomFields {
    companyDateCustomFields {
      customFieldId
      label
    }
  }
`

export const GET_PIPELINE_STALENESS_METRICS = gql`
  query GetPipelineStalenessMetrics($filters: StatusLogFiltersInput) {
    pipelineStalenessMetrics(filters: $filters) {
      hiringStage
      count
      avgDays
      bucket0to7
      bucket8to14
      bucket15to30
      bucket30plus
    }
  }
`

